<template>
  <div class="tuolele-main-box account-management">
    <div class="tuolele-main-search">
      <el-row type="flex" justify="space-between">
        <el-form :inline="true" :model="search">
          <el-form-item label="选择店铺">
            <el-select v-model="search.shop_id">
              <el-option label="全部" value="" />
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="选择角色">
            <el-select v-model="search.role_id">
              <el-option label="全部" value="" />
              <el-option
                v-for="item in obligationList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="账号昵称">
            <el-input
              v-model="search.nickname"
              clearable
              placeholder="请输入用户昵称"
            />
          </el-form-item>
          <!-- <el-form-item label="是否同步校区" class="last-form-item">
            <el-select v-model="search.synchro_status">
              <el-option label="全部" value="" />
              <el-option label="是" value="1" />
              <el-option label="否" value="0" />
            </el-select>
          </el-form-item> -->
          <!-- <el-tooltip placement="right">
            <div slot="content">
              <p class="el-tooltip__popper-text">
                操作提示：
                <br>编辑账号时勾选同步校区后，若公司后续新建店铺，
                <br>则默认新店铺出现在此账号下
              </p>
            </div>
            <i class="hove-tit el-icon-question" />
          </el-tooltip> -->
        </el-form>
        <div>
          <el-button
            type="primary"
            class="el-button-confirm"
            @click="getAccountList"
          >查询</el-button>
          <el-button
            type="success"
            @click="editAccount('add')"
          >新增员工账号</el-button>
        </div>
      </el-row>
    </div>
    <div class="store-setting-content">
      <el-table :data="tableData" border stripe>
        <el-table-column label="店铺" min-width="120">
          <template slot-scope="scope">
            <span v-if="!needClamp(scope.row.shop_name)">{{ scope.row.shop_name }}</span>
            <span v-else>
              <span v-if="!isExpanded(scope.row.uid)">{{ clampShop(scope.row.shop_name) }}</span>
              <span v-else>{{ scope.row.shop_name }}</span>
              <el-button
                type="text"
                size="mini"
                class="shop-toggle"
                @click="toggleShop(scope.row.uid)"
              >{{ isExpanded(scope.row.uid) ? '收起' : '展开' }}</el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="【ID】账号">
          <template slot-scope="scope">
            <div>ID:{{ scope.row.uid }}</div>
            <div>账号:{{ scope.row.username }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="账号昵称" />
        <el-table-column
          prop="obligation_name"
          label="账号角色"
        />
        <!-- <el-table-column label="账号是否同步校区">
          <template slot-scope="scope">
            <div>
              {{ scope.row.synchro_status == 2 ? "是" : "否" }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="modify_time"
          label="最后操作时间"
        />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="openEditPassword(scope.row)"
            >修改密码</el-button>
            <el-button
              type="text"
              @click="editAccount('edit', scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              class="el-button--delete"
              @click="accountRemove(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="search.p"
          prev-text="上一页"
          next-text="下一页"
          :total="search.total"
          :page-size="search.limit"
          @current-change="getAccountList()"
        />
      </div>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="updatePasswordFormVisible"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="updatePasswordForm"
        :model="passwordForm"
        :rules="passwordRules"
      >
        <!-- <el-form-item label="原登录密码" prop="old_pwd">
          <el-input
            v-model="passwordForm.old_pwd"
            type="password"
            autocomplete="off"
          />
        </el-form-item> -->
        <i style="color: brown;"> * 字母和数字，下划线_及破折号-；6~18个字符</i>
        <el-form-item label="新登录密码" prop="new_pwd">
          <el-input
            v-model="passwordForm.new_pwd"
            type="password"
            autocomplete="off"
          />
        </el-form-item>

        <el-form-item label="确认新密码" prop="confirm_pwd">
          <el-input
            v-model="passwordForm.confirm_pwd"
            type="password"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="confirmUpdatePassword"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'AccountManagement',
  data() {
    return {
      search: {
        role_id: '',
        shop_id: '',
        synchro_status: '',
        p: 1,
        total: 0,
        limit: 20,
        nickname: ''
      },
      obligationList: [],
      shopList: [],
      tableData: [],
      expandedShops: [],
      updatePasswordFormVisible: false,
      passwordForm: {
        old_pwd: '',
        new_pwd: '',
        confirm_pwd: ''
      },
      passwordRules: {
        old_pwd: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入旧密码'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        new_pwd: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入新密码'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        confirm_pwd: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'))
              } else if (value !== this.passwordForm.new_pwd) {
                callback(new Error('两次输入密码不一致!'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {
    this.getObligationList()
    this.getMyShopList()
    this.getAccountList()
  },
  methods: {
    getObligationList() {
      this.$http.getObligationList().then(res => {
        this.obligationList = res.data
      })
    },
    /* 店铺列内容是否过长需要折叠（超过 12 个字符） */
    needClamp(name) {
      return typeof name === 'string' && name.length > 12
    },
    /* 折叠时截断显示 */
    clampShop(name) {
      return this.needClamp(name) ? name.slice(0, 12) + '...' : name
    },
    isExpanded(uid) {
      return this.expandedShops.indexOf(uid) > -1
    },
    toggleShop(uid) {
      const i = this.expandedShops.indexOf(uid)
      if (i > -1) {
        this.expandedShops.splice(i, 1)
      } else {
        this.expandedShops.push(uid)
      }
    },
    getMyShopList() {
      this.$http.getShops().then(res => {
        this.shopList = res.data
      })
    },
    getAccountList() {
      this.$http.getAccountList(this.search).then(res => {
        this.search.total = parseInt(res.data.count)
        this.tableData = res.data.list
      })
    },
    openEditPassword(row) {
      this.passwordForm.uid = row.uid
      this.updatePasswordFormVisible = true
    },
    handleClose() {
      this.updatePasswordFormVisible = false
      this.passwordForm = {}
    },
    confirmUpdatePassword() {
      this.$refs.updatePasswordForm.validate(async valid => {
        if (valid) {
          const ret = await this.$http.updatePassword(this.passwordForm)
          if (ret.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.updatePasswordFormVisible = false
            this.passwordForm = {}
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editAccount(type, row) {
      const uid = row ? row.uid : ''
      this.$router.push({
        path: 'accountAdd',
        query: { uid: uid, type: type }
      })
    },
    accountRemove(row) {
      this.$confirm('确定要移除该账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.accountRemove({ uid: row.uid }).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getAccountList()
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" >
.account-management {
  .el-form-item {
    margin-right: 50px !important;
  }
  .last-form-item {
    margin-right: 0 !important;
  }
  .el-form-item__content {
    width: 180px;
  }
  .shop-toggle {
    padding: 0;
    margin-left: 6px;
    font-size: 12px;
  }
}
</style>
